// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"7154383e","453":"58f24846"}[chunkId] + ".chunk.js";
};